module.exports = __webpack_public_path__ + "static/img/add.413f4e6f.svg";